import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const Calendar = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="currentColor" fillRule="nonzero">
          <g>
            <g>
              <path
                d="M15.967 4c.268 0 .485.217.485.485l-.001.91h1.525c1.05 0 1.91.813 1.987 1.843l.005.148v10.652c0 1.1-.892 1.991-1.992 1.991H6.024c-1.1 0-1.992-.891-1.992-1.99V7.385c0-1.099.892-1.99 1.992-1.99l1.436-.001v-.91c0-.268.217-.485.485-.485s.485.217.485.485l-.001.91h3.086v-.91c0-.268.217-.485.485-.485s.485.217.485.485l-.001.91h2.998v-.91c0-.268.217-.485.485-.485zM7.46 6.396H6.02c-.551 0-.997.445-.997.995v10.643c0 .55.446.995.996.995h11.962c.55 0 .996-.446.996-.995V7.391c0-.55-.446-.995-.996-.995h-1.53v.972c0 .268-.216.485-.484.485s-.485-.217-.485-.485v-.972h-2.998v.972c0 .268-.216.485-.484.485s-.485-.217-.485-.485v-.972H8.429v.972c0 .268-.216.485-.484.485s-.485-.217-.485-.485v-.972zm5.19 8.665c.146 0 .265.118.265.264v.888c0 .146-.119.265-.265.265h-1.389c-.146 0-.264-.119-.264-.265v-.888c0-.146.118-.264.264-.264h1.39zm3.67 0c.146 0 .264.118.264.264v.888c0 .146-.118.265-.264.265h-1.39c-.146 0-.264-.119-.264-.265v-.888c0-.146.118-.264.265-.264h1.389zm-7.339 0c.146 0 .265.118.265.264v.888c0 .146-.119.265-.265.265H7.592c-.146 0-.264-.119-.264-.265v-.888c0-.146.118-.264.264-.264h1.39zm7.255-2.75c.146 0 .265.118.265.264v.888c0 .146-.119.264-.265.264h-1.389c-.146 0-.264-.118-.264-.264v-.888c0-.146.118-.265.264-.265h1.39zm-3.586 0c.146 0 .265.118.265.264v.888c0 .146-.119.264-.265.264h-1.389c-.146 0-.264-.118-.264-.264v-.888c0-.146.118-.265.264-.265h1.39zm-3.669 0c.146 0 .265.118.265.264v.888c0 .146-.119.264-.265.264H7.592c-.146 0-.264-.118-.264-.264v-.888c0-.146.118-.265.264-.265h1.39zm0-2.75c.146 0 .265.118.265.264v.888c0 .146-.119.264-.265.264H7.592c-.146 0-.264-.118-.264-.264v-.888c0-.146.118-.265.264-.265h1.39zm3.67 0c.145 0 .264.118.264.264v.888c0 .146-.119.264-.265.264h-1.389c-.146 0-.264-.118-.264-.264v-.888c0-.146.118-.265.264-.265h1.39zm3.585 0c.146 0 .265.118.265.264v.888c0 .146-.119.264-.265.264h-1.389c-.146 0-.264-.118-.264-.264v-.888c0-.146.118-.265.264-.265h1.39z"
                transform="translate(-579 -447) translate(579 423) translate(0 24)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

Calendar.defaultProps = {
  width: '24px',
  height: '24px',
};

export default Calendar;
